import React from 'react'
import { sermon1, sermon2 } from '../../constants/imageConstants'



function AboutUs() {

  const sermons = [
    {
      name:'Rev Kirubandhan',
      image:sermon1,
      tag_line:'Chief Rev',
      description:''
    },
    {
      name:'Pastor Stalin',
      image:sermon2,
      tag_line:'Pastor',
      description:''
    }
  ]  


  return (
    <div className='w-screen overflow-hidden'>

        <div className="bg-banner3 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-center">
            <h1 className="z-10 text-white bg-[#7b026b]/30 w-max px-10 py-2 md:py-5 text-[16px] md:text-[20px] uppercase font-heading">About us</h1>
            <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
            </div>
        </div>


        <div className='w-[80%] mx-auto py-10'>
          <h6 data-aos="fade-up" className='font-body text-[15px]'><span className='font-heading'>IMMANUEL GOSPEL PRAYER HOUSE (CHURCH)</span>, located in Kamalanagar, Bengaluru, was founded in 1991 by Apostle D Arumairaj and is currently led by Pastor K Selvaraj. It is a proud unit of Immanuel Gospel Ministries, headed by <span className='font-heading text-[#7b026b]'>Rev. A Kirubainathan.</span></h6>
          <br></br>
          <h6 data-aos="fade-up" className='font-body text-[15px]'>
          Since its inception, the church has been dedicated to being a vibrant place of praise, worship, and spiritual growth for the local community. The Church has grown both in size and spiritual influence, offering regular worship services, prayer meetings, and community outreach programs designed to uplift and support individuals and families.</h6>
          <br></br>
        
           <h6 data-aos="fade-up" className='font-body text-[15px]'><span className='font-heading text-[#7b026b]'>Immanuel Gospel Prayer House</span> welcomes everyone to join its fellowship, experience God’s love, and grow in their spiritual journeys.</h6>
        </div>

        <div data-aos="fade-left" className='w-[80%] bg-[#7b026b]/20 mb-20 mx-auto p-10'>
              <h6 className='font-body text-[15px]'>
              The church’s core values emphasize faith, fellowship, prayer, service, and biblical teaching. It strives to provide a nurturing environment where believers can deepen their relationship with God and each other. Worship is viewed as a powerful vehicle for transformation, and prayer is central to the church’s life, offering strength and guidance to all.
              Being a part of Immanuel Gospel Ministries, the church shares in a wider vision of spreading the love and teachings of Jesus Christ across communities. This connection offers additional support and resources, enriching the Kamalanagar congregation’s ability to serve and grow in faith.</h6>
              <br></br>
        </div>

        <h6 data-aos="fade-up" className='text-[25px] mb-20 text-center font-thicker tracking-widest'>Pastor's Message</h6>

        <div className='w-[80%] my-14 md:my-10 md:h-[450px] mx-auto'>
          <div data-aos="fade-right" className='md:flex my-10'>
            <div className='md:min-w-[65%] md:max-w-[65%]'>
              <h6 className='text-[16px] font-body mb-2'>It is my joy to share with you the powerful message of hope, healing, and transformation found in Jesus Christ. Life can be difficult, and many of us face struggles like hunger, loneliness, and brokenness. But I want to assure you that God’s love is greater than any challenge.</h6>
              <h6 className='text-[16px] font-body mb-2'>Our church is not just a place for worship, it is a spiritual army called to bring God’s kingdom to earth. We are called to be His hands and feet, reaching out with compassion to those in need, healing the brokenhearted, freeing the captive, and sharing the good news of salvation.</h6>
              <h6 className='text-[16px] font-body mb-2'>Through faith in Jesus, lives are changed, sins forgiven, and brokenness restored. I invite you to experience this life-changing power for yourself. Whether you seek healing, peace, or a purpose-filled life, come and join us on this journey of faith. Together, let us rise as a faithful community, transformed by God’s grace, ready to serve and impact the world.</h6>
              <h6 className='text-[16px] font-body mb-2'>May God bless you richly and guide your steps as you seek Him.</h6>
              <h6 className='text-[18px] font-heading mb-2'> Rev K. Selvaraj</h6>
            </div>
            <div data-aos="fade-left" className='mt-10 md:mt-0 md:ml-[5%] md:min-w-[30%] relative border-[10px] border-[#7b026b]/40 md:max-w-[30%] bg-[#7b026b]/5 mix-blend-multiply'>
              <img className='w-[100%] h-[400px] object-cover mix-blend-multiply' src={sermon1} alt={sermon1} />
              <div className='min-w-[60px] animate-bounce min-h-[60px] border-[10px] border-[#7b026b] absolute -top-[40px] right-[15px]'></div>
              <div className='min-w-[60px] animate-bounce min-h-[60px] border-[10px] border-[#7b026b] absolute -bottom-[40px] left-[15px]'></div>
            </div>
          </div>
        </div> 

         <div className='w-[80%] my-14 md:my-10 md:h-[450px] mx-auto'>
          <div className='md:flex'>

             <div data-aos="fade-right" className='md:mr-[5%] md:min-w-[30%] relative border-[10px] border-[#7b026b]/40 md:max-w-[30%] bg-[#7b026b]/5 mix-blend-multiply'>
              <img className='w-[100%] h-[400px] object-cover mix-blend-multiply' src={sermon2} alt={sermon2} />
              <div className='min-w-[60px] animate-bounce min-h-[60px] border-[10px] border-[#7b026b] absolute -top-[40px] right-[15px]'></div>
              <div className='min-w-[60px] animate-bounce min-h-[60px] border-[10px] border-[#7b026b] absolute -bottom-[40px] left-[15px]'></div>
            </div>

            <div data-aos="fade-left" className='mt-10 md:mt-0 md:min-w-[65%] md:max-w-[65%]'>
              <h6 className='text-[16px] font-body mb-2'>Greetings in the grace and peace of our Lord Jesus Christ. It is a privilege to minister to the youth and to all who seek a deeper walk with God. In this season, the call for young believers is to rise up in faith, purpose, and spiritual power. The challenges of life may be many, but God’s Word reminds us that we are more than conquerors through Christ</h6>
              <h6 className='text-[16px] font-body mb-2'>As young people, you are the hope of the church and the leaders of tomorrow. Embrace the calling to live a life of holiness, passion for God, and steadfast commitment to His kingdom. Stand firm against the pressures of the world and shine as lights in the darkness. God desires to use each one of you mightily to transform your generation by the power of the Holy Spirit.</h6>
              <h6 className='text-[16px] font-body mb-2'>I encourage you to seek God daily, deepen your relationship with Him, and be bold witnesses of His love and truth. Remember, the church grows strong when the youth are strong in the Lord. Let us partner together in faith, prayer, and action to see lives changed and souls won for Jesus Christ.</h6>
              <h6 className='text-[16px] font-body mb-2'>May God bless you abundantly and empower you to fulfill the divine purpose He has placed upon your life.</h6>
              <h6 className='text-[18px] font-heading mb-2'>Pastor Joshua Stalin S</h6>
            </div>
           
          </div>
        </div> 

       
    </div>
  )
}

export default AboutUs